import React from "react";
import oneNote from '../../assets/images/file_icons/one-note.svg';
import youtube from '../../assets/images/file_icons/youtube.svg';
var NoteDescription = function NoteDescription(_ref) {
  var showNotes = _ref.showNotes;
  return /*#__PURE__*/React.createElement("div", {
    className: "mt-2"
  }, showNotes && /*#__PURE__*/React.createElement("small", {
    className: "form-text text-muted pt-2"
  }, "Briefly describe how long you spent on this assessment and how easy or difficult you found it."), /*#__PURE__*/React.createElement("small", {
    className: "form-text text-muted"
  }, "You can paste OneNote ", /*#__PURE__*/React.createElement("img", {
    src: oneNote,
    alt: "One note icon",
    className: "small-img"
  }), ", YouTube ", /*#__PURE__*/React.createElement("img", {
    src: youtube,
    alt: "Youtube icon",
    className: "small-img"
  }), " and other URLs here."));
};
NoteDescription.defaultProps = {
  showNotes: true
};
export default NoteDescription;